import Attachment from "@/modules/fileManagement/service/attachment.repo.ts";
import Vue from "vue";
import { store } from "@/main";

export const addAttachmentCode = async (resource, resource_id, description) => {
  let attachment_temps = store.state.fileManagement.attachment_temp_code;
  let codes = [];
  await attachment_temps.map(async (attachment_temp) => {
    if ("code" in attachment_temp) {
      // this.postAttachment(attachment_temp.code);
      codes.push({
        resize_avatar: false,
        code: attachment_temp.code,
      });
    }
  });
  let res = {};
  try {
    if (codes.length > 0) {
      let payload = { data: codes };
      const response = await Attachment.create(payload, resource, resource_id);
      let failCodes = response.data.data.fail_codes;
      if (failCodes && failCodes.length > 0) {
        attachment_temps.map((x) => {
          if (failCodes.includes(x.code)) {
            description = description.replace(x.url, "");
          }
        });

        res = {
          fail_codes: true,
          description,
        };
        return res;
      }
      res = {
        fail_codes: false,
        description,
      };
      return res;
    } else {
      res = {
        fail_codes: false,
        description,
      };
      return res;
    }
  } catch (error) {
    Vue.prototype.$generateError(error);
    res = {
      fail_codes: false,
      description,
    };
    return res;
  } finally {
    store.commit("fileManagement/clearAttachmentTempCode");
  }
};
